import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { Typography, IconButton } from '@material-ui/core';
import { ClearIcon } from '../icons';
import { isBrowser } from '../browserUtils';

const styles = theme => ({
    root: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        flex: '1 1 auto',
    },
    icon: {
        height: 'auto',
        width: 'auto',
    },
});

class ErrorMessage extends React.Component {
    errorElement = React.createRef();

    componentDidUpdate(prevProps) {
        if (this.props.message && this.props.message !== prevProps.message) {
            const scrollEl = this.errorElement.current;

            if (scrollEl && isBrowser && window.scrollY > 10) {
                setTimeout(() => {
                    scrollEl.scrollIntoView({ behavior: 'smooth' });
                }, 200);
            }
        }
    }

    render() {
        const {
            classes, translate, message, onClear, className, muteErrors, scrollMarginTop,
        } = this.props;

        if (!message) {
            return null;
        }

        const filteredMessages = [...new Set(message.split('<br/>'))].filter(d => !muteErrors?.includes(d));

        if (!filteredMessages.length) {
            return null;
        }
        return (
            <div className={classnames(classes.root, className)} ref={this.errorElement} style={{ scrollMarginTop }}>
                {filteredMessages.map(msg => (
                    <Typography key={msg} color="error" className={classes.text}>
                        {translate(`errors.${msg}`, null, { onMissingTranslation: () => `System error (${msg})` })}
                    </Typography>
                ))}
                {onClear && (
                    <IconButton onClick={onClear} className={classes.icon} color="secondary" aria-label={translate('clear')}>
                        <ClearIcon />
                    </IconButton>
                )}
            </div>
        );
    }
}

ErrorMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    className: PropTypes.string,
    message: PropTypes.string,
    onClear: PropTypes.func,
    muteErrors: PropTypes.array,
    scrollMarginTop: PropTypes.number,
};

ErrorMessage.defaultProps = {
    message: null,
    className: null,
    onClear: null,
    muteErrors: null,
    scrollMarginTop: null,
};


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(ErrorMessage));
